module.exports = __webpack_public_path__ + "static/media/logo_2.27fb4463.png";